import { render, staticRenderFns } from "./TokenStatistic.vue?vue&type=template&id=7f6be4da&scoped=true&"
import script from "./TokenStatistic.vue?vue&type=script&lang=js&"
export * from "./TokenStatistic.vue?vue&type=script&lang=js&"
import style0 from "./TokenStatistic.vue?vue&type=style&index=0&id=7f6be4da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6be4da",
  null
  
)

export default component.exports